import api from "./api";
import { getConsent } from "../analytics/posthog";

// Persists the analytics consent choice on the account so server-side events respect it.
export function syncConsentToServer(granted) {
  return api.post("/me/analytics-consent", { granted }).catch(() => {});
}

// Aligns the account with the choice stored in this browser (e.g. chosen before login).
export function reconcileConsent(user) {
  const c = getConsent();
  if (!user || !user.user_id || !c) return;
  if (user.analytics_consent !== c) syncConsentToServer(c === "granted");
}
